import { useEffect, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';

export function useInviteeManagement() {
  const [inviteeIds, setInviteeIds] = useState([uuidv4()]);
  const [emailInvitations, setEmailInvitations] = useState<Set<string>>(new Set());
  const [canSendEmail, setCanSendEmail] = useState(false);

  const addInvitee = () => setInviteeIds([...inviteeIds, uuidv4()]);

  const removeInvitee = (id: string) => {
    setInviteeIds(inviteeIds.filter((inviteeId) => inviteeId !== id));
  };

  const addEmail = (id: string) => setEmailInvitations(new Set(emailInvitations).add(id));

  const removeEmail = (id: string) => {
    const updatedEmails = new Set(emailInvitations);
    updatedEmails.delete(id);
    setEmailInvitations(updatedEmails);
  };

  const toggleSendEmail = () => {
    if (emailInvitations.size > 0) {
      setCanSendEmail(!canSendEmail);
    }
  };

  useEffect(() => {
    if (!emailInvitations.size && canSendEmail) {
      return setCanSendEmail(false);
    } else if (emailInvitations.size > 0 && !canSendEmail) {
      return setCanSendEmail(true);
    }
  }, [emailInvitations.size]);

  return {
    inviteeIds,
    emailInvitations,
    canSendEmail,
    setCanSendEmail,
    addInvitee,
    removeInvitee,
    addEmail,
    removeEmail,
    toggleSendEmail,
  };
}
